import { useState } from "react";
import { Locale } from "antd/es/locale-provider";
import i18n from "i18n";
import enLocale from "antd/es/locale/en_US";
import deLocale from "antd/es/locale/de_DE";
import viLocale from "antd/es/locale/vi_VN";
import itLocale from "antd/es/locale/it_IT";
import frLocale from "antd/es/locale/fr_FR";
import jpLocale from "antd/es/locale/ja_JP";

const useAntLocale = () => {
  const mapLngToAntLocale = (lng: string): Locale => {
    switch (lng) {
      case "en":
        return enLocale;
      case "de":
        return deLocale;
      case "vi":
        return viLocale;
      case "it":
        return itLocale;
      case "fr":
        return frLocale;
      case "jp":
        return jpLocale;
      default:
        return enLocale;
    }
  };

  const currentLng = i18n.language;

  const locale = mapLngToAntLocale(currentLng);
  const [antLocale, setAntLocale] = useState<Locale>(locale);

  const changeAntLocale = (lng: string) => {
    const newLocale = mapLngToAntLocale(lng);
    setAntLocale(newLocale);
  };

  return {
    antLocale,
    changeAntLocale,
  };
};

export default useAntLocale;
